import apiClient from "../core/HttpClient";
import { EmailTemplate } from "../models";

export default class EmailTemplatesService {
  url = "/EmailTemplates";
  async getEmailTemplates(): Promise<EmailTemplate[]> {
    return apiClient.get<any[]>(this.url).then((response) => {
      return response.data;
    });
  }
  async getEmailTemplateById(id: string): Promise<EmailTemplate> {
    return apiClient.get<any>(this.url + `/${id}`).then((response) => {
      return response.data;
    });
  }
  async updateEmailTemplate(id: string, data: any) {
    return apiClient.put(`${this.url}/${id}`, data);
  }
  async deleteEmailTemplate(id: string) {
    return apiClient.delete(`${this.url}/${id}`);
  }
  async createEmailTemplate(data: any) {
    return apiClient.post(this.url, data);
  }
}
